import OrderDTO from "@/dto/order/OrderDTO";
import React from "react";
import { ShipValidationRule, ShipValidationRuleKey } from "../type";
import { buildValidationSuccessfulResult } from "../util";
import { isAnyOrderInputtedWaybillNo } from "@/utils/OrderUtils";
import { Input, Modal } from "antd";

// 生成指定区间随机数
function randomIntFromInterval(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

// 生成4位数验证码
function generateConfirmCode() {
    const confirmCode = [];
    for (let i = 0; i < 4; i++) {
        confirmCode.push(randomIntFromInterval(0, 9));
    }
    return confirmCode.join("");
}

function virtualShipConfirm() {
    return new Promise<boolean>((yes, no) => {
        const confirmCode = generateConfirmCode();

        let inputValue = "";

        Modal.confirm({
            title: "所选订单中某些订单已录入运单号，请确认是否使用【无需物流】方式发货？",
            width: 620,
            closable: false,
            keyboard: false,
            content: (
                <>
                    <p className="mt10">如需继续使用【无需物流】发货，请输入以下验证码：{confirmCode}</p>
                    <p className="mt10">
                        <span>验证码：</span>
                        <Input
                            onChange={(e) => {
                                inputValue = e.target.value;
                            }}
                        />
                    </p>
                </>
            ),
            okButtonProps: {
                type: "primary",
                danger: true,
            },
            okText: "确认使用【无需物流】发货",
            onOk() {
                if (inputValue !== confirmCode) {
                    return Promise.reject("验证码输入不正确！");
                }

                yes(true);
            },
            onCancel() {
                no();
            },
        });
    });
}

export default async function validateVirtualShip(orders: OrderDTO[], rule: ShipValidationRule) {
    if (!rule[ShipValidationRuleKey.checkVirtualShip]) return buildValidationSuccessfulResult(orders);

    if (isAnyOrderInputtedWaybillNo(orders)) {
        await virtualShipConfirm();
    }

    return buildValidationSuccessfulResult(orders);
}
